<template>
    <div class="page-block__item">
        <div class="page-block__item-content">
            <div class="layout">
                <div class="layout__item u-1/3-desk">
                    <span class="page-block__item-content-title">
                        {{ label }}
                    </span>
                </div>
            </div>
        </div>
        <div class="page-block__item-nav">
            <button type="button" class="btn btn--ghost btn--ghost-full-width" @click="openPrivateKeyModal">
                {{ trans('ssl.private_key_button') }}
            </button>
        </div>
        <ssl-private-key-modal v-if="privateKeyModalVisible" :subscription="subscription"></ssl-private-key-modal>
    </div>
</template>

<script>
import SslPrivateKeyModal from "./SslPrivatekeyModal";
export default {
    name: "SslPrivateKey",
    components: {SslPrivateKeyModal},
    props: {
        label: {
            type: String,
            required: true
        },
        subscription: {
            type: Object,
            required: true
        }
    },
    mounted(){
        /**
         * Receiving call from child component
         */
        this.$root.$on('closedModal',() => {
           this.closePrivateKeyModal();
        });
    },
    data() {
        return {
            privateKeyModalVisible: false,
        };
    },
    methods: {
        /**
         * open the private key modal.
         */
        openPrivateKeyModal() {
            this.privateKeyModalVisible = true;
        },
        /**
         * close the private key modal.
         */
        closePrivateKeyModal(){
            this.privateKeyModalVisible = false;
        }
    }
}
</script>
